import {activeUser} from "../../system/types/activeUser/activeUserType";

export enum ACTIVE_USER_ACTIONS {
    setActiveToken = 'SET_ACTIVE_USER_TOKEN',
    setEmail = 'SET_ACTIVE_USER_EMAIL',
    setUserData = 'SET_ACTIVE_USER_DATA',
    setUserIsValid ='SET_ACTIVE_USER_IS_VALID',
    clearData ='CLEAR_ACTIVE_USER_DATA'
}

export type ActiveUserState = {
    activeUserToken: string,
    activeUserEmail: string,
    activeUserIsValid: boolean,
    activeUserData: activeUser,
};

